<template>
  <div v-if="_visible" class="addApplicationMange">
    <module-title :title="handleType === 'add' ? '添加应用' : '编辑应用'">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="back">
          返回
        </el-button>
      </div>
    </module-title>
    <div class="add-application-wrapper">
      <el-form
        ref="addApplicationForm"
        class="add-application-form"
        :model="addApplicationForm"
        :rules="handleRules"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="应用编码：" prop="code">
          <el-input
            v-model="addApplicationForm.code"
            on-key-up="value=value.replace(/[\W]/g,'')"
            placeholder="请输入应用编码"
            class="handle-form-input"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="应用类型：" prop="appType">
          <el-select
            v-model="addApplicationForm.appType"
            class="handle-form-input"
          >
            <el-option label="课堂活动应用" value="0" />
            <el-option label="系统内置应用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="应用名称：" prop="name">
          <el-input
            v-model="addApplicationForm.name"
            name="name"
            :maxlength="10"
            placeholder="请输入应用名称"
            class="handle-form-input"
            :disabled="handleType === 'edit'"
          />
        </el-form-item>

        <el-form-item label="应用详情：" prop="describes">
          <Editor
            :is-img="false"
            :decimal-num="1000"
            :editor-content="addApplicationForm.describes"
            @editorChange="editorChangeFn"
          />
        </el-form-item>
      </el-form>
      <div class="addApplicationMange-footer">
        <el-button
          size="medium"
          @click="back"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          :loading="ajaxLoading"
          @click="handleAddApplication"
        >
          {{ ajaxLoading ? '提交中...' : '提交' }}
        </el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogImageVisible" title="预览图片">
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>

<script>

import {
  addApp,
  updateApp,
  appCode
} from '@/api/productOperation/classRoom/applicationList';

import { mapGetters } from 'vuex';
export default {
  name: 'AddApplicationMange',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    handleType: {
      type: String,
      required: true
    },
    applicationDetail: {
      type: Object,
      default: () => []
    }
  },
  data() {
    return {
      appid: '',
      dialogImageVisible: false,
      dialogImageUrl: '',
      ajaxLoading: false, //  表单提交loading
      addApplicationForm: {
        appType: '',
        code: '', // 应用编码
        name: '',
        describes: ''
      },
      codeArr: [], // 应用编码
      handleRules: {
        code: [{ required: true, message: '应用编码不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '应用名称不能为空', trigger: 'blur' }],
        appType: [{ required: true, message: '应用类型不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    ...mapGetters(['userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
  },
  mounted() {
    this.initForm();
    if (this.handleType === 'edit') {
      console.log(typeof this.applicationDetail.appType);

      this.addApplicationForm = {
        code: this.applicationDetail.code,
        name: this.applicationDetail.name,
        appType: this.applicationDetail.appType.toString(),
        describes: this.applicationDetail.appDetail,
        createUserCode: this.userCode
      };
      this.appid = this.applicationDetail.id;
    } else {
      this.$refs.addApplicationForm.resetFields();
    }
  },
  methods: {
    change() {
      this.$forceUpdate();
    },
    initForm() {
      appCode().then(res => {
        this.codeArr = res.data;
      });
    },
    editorChangeFn(val) {
      this.addApplicationForm.describes = val;
    },
    // 返回
    back() {
      // true 提示， false直接返回
      if (this.handleType !== 'add') {
        this._visible = false;
        return;
      }
      const flag = Object.values(this.addApplicationForm).some((item) => {
        return item.length > 0;
      });
      if (!flag) {
        this._visible = false;
      } else {
        this.$confirm('您已输入部分内容，是否确认返回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this._visible = false;
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消返回!'
            });
          });
      }
    },
    // 添加应用
    handleAddApplication() {
      console.log(typeof this.addApplicationForm.appType);

      this.$refs['addApplicationForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          const data = {
            code: this.addApplicationForm.code,
            name: this.addApplicationForm.name,
            appType: this.addApplicationForm.appType,
            appDetail: this.addApplicationForm.describes,
            createUserCode: this.userCode
          };
          if (this.handleType === 'add') {
            addApp(data)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.$emit('onSuccess');
                this._visible = false;
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            updateApp(this.appid, data)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.$emit('onSuccess');
                this._visible = false;
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">

.app-update {
  position: relative;
}
.update-text {
  position: absolute;
  left: 180px;
  bottom: 10px;
}
</style>
<style lang="scss" scoped>
.addApplicationMange {
  .add-application-wrapper {
    .add-application-form {
      .handle-form-input {
        width: 350px;
      }
      .downNum {
        margin-left: 20px;
      }
      .handle-form-apptypes {
        width: 50%;
      }
      .handle-form-textarea {
        width: 500px;
      }
    }
    .addApplicationMange-footer {
      text-align: center;
      padding: 20px;
    }
  }
}
.group{
  max-width: 800px;
}
</style>
